module.exports = __webpack_public_path__ + "media/images/icon-cancel-58582e94f68830783479f1958382fe00.svg";